import { Component, EventEmitter, OnChanges, Output } from '@angular/core';
import { DatePickerInlineBaseComponent } from '../date-picker-inline-base/date-picker-inline-base.component';
import { ComponentChanges } from '../../../../../models/component-changes.model';
import * as moment from 'moment';

/**
 * This interface represents month
 */
interface Month {
  /**
   * The date
   */
  date: moment.Moment;

  /**
   * The flag indicating current
   */
  isCurrent: boolean;
}

/**
 * This component represents the list of months
 */
@Component({
  selector: 'ideom-date-picker-inline-months',
  templateUrl: './date-picker-inline-months.component.html',
  styleUrls: ['./date-picker-inline-months.component.scss'],
})
export class DatePickerInlineMonthsComponent extends DatePickerInlineBaseComponent implements OnChanges {
  /**
   * The item click event
   */
  @Output() itemClick: EventEmitter<void> = new EventEmitter<void>();

  /**
   * The list of months
   */
  months: Month[] = [];

  constructor() {
    super();
  }

  ngOnChanges(changes: ComponentChanges<DatePickerInlineMonthsComponent>): void {
    if (changes.current) {
      this.updateMonths();
    }
  }

  /**
   * This method is used for handling click to month
   * @param month The month
   */
  onMonthClick(month: Month): void {
    this.currentChange.emit(moment(month.date));
    this.itemClick.emit();
  }

  /**
   * This method is used for updating months
   * @private
   */
  private updateMonths(): void {
    const months: Month[] = [];
    const yearStart = moment(this.current).startOf('year');
    const yearEnd = moment(this.current).endOf('year').startOf('month');

    let month = moment(yearStart);

    while (month.isSameOrBefore(yearEnd, 'month')) {
      months.push({
        date: month,
        isCurrent: month.isSame(this.current, 'month'),
      });
      month = moment(month).add(1, 'month');
    }
    this.months = months;
  }
}
